<template>
	<main class="ws-view" v-bind="$attrs">
		<slot />
	</main>
</template>

<script setup lang="ts">
defineOptions({
	inheritAttrs: false
});
</script>

<style lang="scss" scoped>
.ws-view {
	display: flex;
	flex-direction: column;
	flex: 1 1 0%;
	position: relative;
	padding: 1rem 1.25rem 5rem;
	overflow-y: hidden;
	background-color: $background;
	min-height: calc(99vh - #{$navbar-height});

	& > * {
		height: 100%;
		width: 100%;
	}
}
</style>
